/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import AcknowledgedAction from './AcknowledgedAction/index'
import Alerts from './Alerts/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/PatientNotifications/Content/Content/Content"
  
}) {
let notificationsAlertsLengthValueData = fromData.useDataValue({ viewPath,
context: 'notifications',
path: 'alerts.length',
})
let patientPersonValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'person',
})
let aggregateData = fromHelpers.getTitle(notificationsAlertsLengthValueData, patientPersonValueData)
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 size="medium"
 dangerouslyBypassFocusLock={true}
 maxHeight="90%"
 paddingLeft={24}
 paddingRight={24}
 paddingTop={12}
 paddingBottom={12}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 data="notifications.alerts.length"
 data="patient.person"
 aggregate="helpers.js getTitle"
 text={aggregateData}
/>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<Alerts
  viewPath={`${viewPath}/Alerts`}
/>
</div>
<AcknowledgedAction
  viewPath={`${viewPath}/AcknowledgedAction`}
/>
</div>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}